import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { START } from 'pu-data/QuoteSteps'


const title = (props) => {
  const l = ['USA PCBs']
  if (props.quoteStep !== START && props.parametersCustomer) {
    if (props.parametersCustomer.has_array === '0') {
      l.push('Individual Boards')
    } else if (props.parametersCustomer.tab_rout === '1') {
      l.push('Tab Routed Panels')
    } else if (props.parametersCustomer.scoring === '1') {
      l.push('V-Score Panels')
    }
  }

  return _.join(l, ' - ')
}

const PriceMatrixTitle = props => (<h2>{title(props)}</h2>)

PriceMatrixTitle.propTypes = {
  parametersCustomer: PropTypes.object.isRequired,
  quoteStep: PropTypes.string.isRequired,
}

export default PriceMatrixTitle
